import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table, Badge, Row, Col, Button, Modal, Alert, Form } from "react-bootstrap";
import { LuLayoutGrid, LuFileSliders, LuPenLine, LuFilePenLine, LuTrash2 } from "react-icons/lu";
import { FaRegHandPointUp } from "react-icons/fa";
// import { motion } from "framer-motion";
import { useForm, Controller } from 'react-hook-form';
import API from "../../../services/axiosInstance";
import CommonPagination from "../../utils/CommonPagination";
import "./ActivePublisher.css";
import { loggedInUserDetails, makePageableData } from "../../utils/helper";
// import { makePageableData } from "../../utils/helper";
import Pagination from "../../common_modules/pagination";
import FilterBar from "../../common_modules/filter";
import Permission from "../../security/permission";
import { AUTH_CODE } from "../../security/authCodes";
import { FormLoader, useFormLoader } from "../../common_modules/loader";
import { SearchIcon } from "../../common_modules/commonIcons";

const publishers = [
  { name: "Acc_Pub_Sales", status: "Active", company: "test", invoiceStatus: "Invoice Pending" },
  { name: "Adgebra API Pub 2", status: "Active", company: "wew", invoiceStatus: "Invoice Pending" },
  { name: "ADM billing Pub", status: "Active", company: "soniya", invoiceStatus: "Invoice Pending" },
  { name: "AdZebra API Publisher", status: "Active", company: "", invoiceStatus: "Completed" }
];

// const getInvoiceBadge = (status) => {
//   switch (status) {
//     case "Completed":
//       return <Badge bg="success" pill>Completed</Badge>;
//     case "Invoice Pending":
//       return <Badge bg="warning" text="dark" pill>Pending</Badge>;
//     default:
//       return <Badge bg="secondary" pill>{status}</Badge>;
//   }
// };

// const iconButtons = [
//   { icon: <FaUser />, label: "View Account", variant: "outline-primary" },
//   { icon: <FaFileInvoice />, label: "Manage Invoice", variant: "outline-success" },
//   { icon: <FaCogs />, label: "Invoice Settings", variant: "outline-secondary" },
//   { icon: <FaEdit />, label: "Edit", variant: "outline-dark" }
// ];

const ActivePublishersTable = () => {
  const [activePubs, setActivePubs] = useState([]);
  const [deactivateModal, setDeactivateModal] = useState(false);
  const [selectedPub, setSelectedPub] = useState(null);
  const [actionType, setActionType] = useState(null);
  const [actionModal, setActionModal] = useState(false);
  // pagination & filetr states 
  const [paginationData, setPaginationData] = useState({});
  const [searchConfig, setSearchConfig] = useState({});

  // const [page, setPage] = useState(0);
  // const [size, setSize] = useState(10);   // how many rows per page
  // const [totalPages, setTotalPages] = useState();
  // const [totalItems, setTotalItems] = useState();
  const [loginUser, setLoginUser] = useState(loggedInUserDetails);

  // const hideDeactivateModal = () => setDeactivateModal(false);    
  // const showDeactivateModal = () => setDeactivateModal(true);

  const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook loader

  const tableFields = [
    { label: "ID", value: "id", enableSorting: true, enableTableHeader: false, enableIcon: true },
    { label: "Name", value: "name", enableSorting: true, enableTableHeader: true, enableIcon: true },
    { label: "Status", value: "status", enableSorting: false, enableTableHeader: true, enableIcon: false },
    { label: "Company Name", value: "", enableSorting: false, enableTableHeader: true, enableIcon: true },
    { label: "Invoice Status", value: "", enableSorting: false, enableTableHeader: true, enableIcon: false },
    { label: "Payoneer ID", value: "", enableSorting: false, enableTableHeader: true, enableIcon: true },
  ];

  const openActionModal = (type, pub) => {
    setSelectedPub(pub);
    setActionType(type);
    setActionModal(true);
  }

  const closeActionModal = () => {
    setActionModal(false);
    setSelectedPub(null);
    setActionType(null);
    reset();
  }
  const { handleSubmit, register, reset, formState: { errors }, } = useForm({})

  const activePubList = async (search, page, field = "", order = "") => {
    startLoading();
    try {
      const size = 20;
      const pubListRes = await API.get(`/publisher/listing?search=${search}&page=${page}&size=${size}&field=${field}&order=${order}`);
      const data = pubListRes?.data?.data?.content || {};
      const pagination = pubListRes?.data?.data || {};
      console.log(pubListRes.data.status);

      if (pubListRes?.data?.status === "Success" && data) {
        setActivePubs(data);
        delete pagination.content; //  remove data
        setPaginationData(pagination);
      }
      console.log(pubListRes.data.data.pageable.pageSize);

      // pagination state
      // const pageableData = makePageableData(pubListRes.data.data.totalElements, size, pubListRes.data.data.number, pubListRes.data.data.content.length);

      // setTotalPages(pubListRes.data.totalPages);
      // setTotalItems(pubListRes.data.totalElements);
      // setSize(pubListRes.data.size);

    } catch (error) { console.error("API Error:", error); }
    finally {
      stopLoading();
    }
  }

  const nextPage = (nextPage) => {
    activePubList("", nextPage, searchConfig?.orderField, searchConfig?.orderDir)
  }

  const onChangeSearch = (params) => {
    setSearchConfig(params)
    activePubList(params.keyword, 0, params.orderField, params.orderDir); // API call
  }

  const onSubmit = async (data) => {
    if (!selectedPub) return;

    const isConfirmed = window.confirm(
      actionType === "deactivate"
        ? "Do you want to deactivate this publisher?"
        : "Do you want to reject this publisher?"
    );

    if (!isConfirmed) return;

    const payload = {
      guid: selectedPub?.guid,
      status: actionType === "deactivate" ? 5 : 4,
      comment: actionType === "deactivate" ? data?.comment : "",
    }
    try {
      await API.put('/publisher/update/status', payload);
      // window.confirm("Do you want to deactivate Publisher");
      closeActionModal();
      // refresh list
      activePubList("", 0);
    } catch (error) {
      console.error("API Error:", error);
    }
  }

  const getInvoiceSettingInfo = async (userId) => {
    try {
      const response = await API.get(`/publisher/invoice/setting/limited/${userId}`);
      if (response.status === 200) {
        return response.data.data;
      }
    } catch (error) { } finally {
      stopLoading();
    }
    return false;
  }

  const viewPubDashboard = async (data) => {
    const domain = process.env.REACT_APP_DOMAIN_VIEW_DASHBOARD;
    const width = 800;
    const height = 600;
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const left = (screenWidth - width) / 2;
    const top = (screenHeight - height) / 2;
    let url = `${domain}/view/dashboard?name=${data.userId}&t=${localStorage.getItem("token")}`;

    // check invoice setting saved then
    const invoiceSetting = await getInvoiceSettingInfo(data.loginUserId);
    if (invoiceSetting) {
      window.open(
        url,
        "_blank",
        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
      );
    } else {
      alert(`The invoice setting for publisher "${data?.userId}" has not been saved yet. Please save the invoice setting first and try again.`);
    }
  }

  useEffect(() => {
    activePubList("", 0);
  }, []);

  return (
    <FormLoader isLoading={isLoading} text={"Loading..."}>
      {/* <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className=""
      > */}
      <div className="breadCrumb gradient-bg">
        <Link to={'/dashboard'}><span>Home</span></Link>
        <span>Active Publisher</span>
      </div>
      <h4 className="my-4">🧾 Active Publishers</h4>

      <Row className="filter">
        <Permission code={AUTH_CODE.financeInvoice.invoiceRecentActivity}>
          <Link style={{ color: "#ffffff", textDecoration: "none", width: "auto" }} to={'/publisher/recent-invoice/'}>
            <button className="btn btn-primary view-btn" size={"md"}> View Recent Invoice Activity  <FaRegHandPointUp />
            </button>
          </Link>
        </Permission>
        <FilterBar fields={tableFields} onSearch={onChangeSearch} />
      </Row>

      {/* <div className="gap-2 activePubAllBtns mb-4">
          
        </div> */}
      <div>
        <div className="mt-0 table-wrapper mt-3">
          <Table striped bordered responsive hover size="sm" className="custom-table align-middle">
            <thead>
              <tr>
                {
                  tableFields?.map((item, i) => {
                    if (!item.enableTableHeader) {
                      return false;
                    }
                    return (
                      <th key={i}>
                        {item.label}
                        {item.enableIcon ? <SearchIcon className="ms-1" size={10} fill="white" /> : ""}
                      </th>
                    )
                  })
                }
                <th className="text-center">Action</th>
                {/* <th>Name</th>
                <th>Status</th>
                <th>Company Name</th>
                <th>Invoice Status</th>
                <th>Payoneer ID</th> */}
                {/* <th className="text-center">Actions</th> */}
              </tr>
            </thead>
            <tbody>
              {activePubs?.length > 0 ? (
                activePubs?.map((pub, index) => (
                  <tr>
                    <td>
                      <Link to={`/publisher/info/${pub?.accId}/${pub?.guid}`} className="text-decoration-none fw-semibold text-primary">{pub?.name} </Link>
                      {/* { loginUser?.accountType == 0 ?
                      <span className="dashboardIcon" onClick={() => viewPubDashboard(pub?.userId)} style={{cursor:"pointer",    color: "#6c757d"}}><LuSquareArrowOutUpRight /></span> : ""
                      } */}
                    </td>
                    <td><span className="badge active">Active</span></td>
                    <td>{pub?.companyName || "—"}</td>
                    {/* <td>{getInvoiceBadge(pub?.invoiceStatus) || '-'}</td> */}
                    <td>{pub?.invoiceStatus || '-'}</td>
                    <td>{pub?.payoneerID || '-'}</td>
                    <td className="">
                      <div className="d-flex flex-nowrap activePubAllBtns">
                        {/* {iconButtons.map((btn, i) => (
                      <OverlayTrigger
                        key={i}
                        placement="top"
                        overlay={<Tooltip>{btn.label}</Tooltip>}
                      >
                        <motion.button
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.95 }}
                          className={`btn btn-sm ${btn.variant} rounded-circle d-flex align-items-center justify-content-center`}
                          style={{ width: "36px", height: "36px" }}
                        >
                          {btn.icon}
                        </motion.button>
                      </OverlayTrigger>
                    ))} */}
                        {/* <button><Link to={`/${pub?.guid}/instream-setting`}><BiLogIn /> Instream Setting</Link></button> */}

                        {/* view publisher dashboard, only admin can view button of view dashboard*/}
                        {/* {loginUser?.accountType == 0 || loginUser?.accountType == 2 ? */}
                        <Permission code={AUTH_CODE.userSecurity.viewDashboard}>
                          <button onClick={() => viewPubDashboard(pub)}>  View Dashboard <LuLayoutGrid /> </button>
                        </Permission>
                        {/* : "" */}
                        {/* } */}
                        {/* <Permission code={AUTH_CODE.instreamTagSetting.instreamTagListing}> */}
                        {/* <button><Link to={`/publisher/instream-setting-list/${pub?.accId}/${pub?.guid}`} state={{ publisherId: pub?.accId, publisherGuid: pub?.guid }}><BiLogIn /> View Account</Link></button> */}
                        {/* </Permission> */}

                        {/* <Permission code={AUTH_CODE.publisherInvoice.publisherListing}> */}
                        <Permission code={AUTH_CODE.financeInvoice.invoiceListing}>
                          <Link to={`/invoice-list/${pub.accId}/${pub?.guid}`} state={{ publisherGuid: pub?.guid, publisherId: pub?.accId }}><button> Manage Publisher Invoice <LuFilePenLine /> </button></Link>
                        </Permission>

                        <Permission code={AUTH_CODE.invoiceSetting.createUpdateInvoiceSetting}>
                          <Link to={`/invoice-setting/${pub.accId}/${pub?.guid}`} state={{ publisherGuid: pub?.guid, publisherId: pub?.accId }}><button> Invoice Setting <LuFileSliders /> </button></Link>
                        </Permission>

                        <Permission code={AUTH_CODE.accounts.editUpdatePublisher}>
                          <Link to={`/publisher/edit/${pub.accId}/${pub?.guid}`}><button> Edit <LuPenLine /></button></Link>
                        </Permission>

                        {/* <button><Link to={`/publisher/gam-setting/${pub.accId}/${pub?.guid}`}><BiEdit /> GAM Setting</Link></button> */}

                        {/* <Permission code={AUTH_CODE.accounts.activateDeactivatePublisher}>
                          <button onClick={() => openActionModal("reject", pub)}> Reject <BiX /></button>
                        </Permission> */}

                        <Permission code={AUTH_CODE.accounts.activateDeactivatePublisher}>
                          <button onClick={() => openActionModal("deactivate", pub)}> Deactivate <LuTrash2 /></button>
                        </Permission>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-4 text-muted fw-bold">
                    No Data Available
                  </td>
                </tr>
              )
              }
            </tbody>
          </Table>
        </div>
      </div>
      {/* deactivate modal start */}
      <Modal show={actionModal} onHide={closeActionModal}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>{actionType === "deactivate" ? "Deactivate Account" : "Reject Account"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Alert variant="success">
              <p className="mb-0" style={{ fontSizxe: "12px" }}>
                {actionType === "deactivate"
                  ? "Note : After Deactivated Accout, Sites status will be auto pending."
                  : "Note : After Rejected Accout, Sites status will be auto rejected."}
              </p>
            </Alert>
            <Row className="mb-4">
              <Col md={4}><label>Account Id</label></Col>
              <Col md={8}><span>{selectedPub?.guid}</span></Col>
            </Row>
            {actionType === "deactivate" && (
              <Row>
                <Col md={4}><label>Comment : <span className="text-danger">*</span></label></Col>
                <Col md={8}>
                  <Form.Select {...register('comment', { required: "Comment is required" })}>
                    <option value="">Please select</option>
                    <option value="Account_found_violating_TnC">Account_found_violating_TnC</option>
                    <option value="Account_earlier_caught_in_fraudulent_activity">Account_earlier_caught_in_fraudulent_activity</option>
                    <option value="Inappropriate_Content">Inappropriate_Content</option>
                    <option value="Shared_Hosting">Shared_Hosting</option>
                    <option value="Adult_Illegal_Content">Adult_Illegal_Content</option>
                    <option value="Unserviceable_Geolocation">Unserviceable_Geolocation</option>
                    <option value="Website_Design_Issues">Website_Design_Issues</option>
                  </Form.Select>
                  {errors.comment && <p className="text-danger">{errors.comment.message}</p>}
                </Col>
              </Row>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="danger">
              {actionType === "deactivate" ? "Deactivate" : "Reject"}
            </Button>
            <Button variant="secondary" onClick={closeActionModal}>
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Pagination
        jumpPage={true}
        initCall={false}
        count={true}
        component={ActivePublishersTable.name}
        size={"sm"}
        paginationData={paginationData}
        nextPage={nextPage} />
      {/* <CommonPagination
          page={''}
          totalPages={''}
          size={''}
          totalItems={''}
          setPage={''}
        /> */}
      {/* </motion.div> */}
    </FormLoader >
  );
};

export default ActivePublishersTable;
